<template>
    <Modal
        ref="modal"
        :width="viewport.is.mobile ? '100%' : '375px'"
        class="resume"
        compact
        :drawer="viewport.is.mobile"
        @close="$emit('close')"
    >
        <template #header>
            <Txt size="xs" heading>
                Welcome back! 👋
            </Txt>
        </template>
        <Txt>
            Would you like to resume the course where you left off?
        </Txt>
        <template #footer>
            <Button
                variant="basic"
                colour="anchor"
                icon="reverse"
                icon-size="20"
                icon-pos="left"
                size="xxs" heading
                slim
                @click="
                    $emit('reset');
                    $refs.modal.close();
                "
            >
                Restart
            </Button>
            <Button
                icon="resume"
                icon-size="20"
                size="xxxs" heading
                slim
                :colour="course.theme.colours.standard.primary"
                @click="$refs.modal.close"
            >
                Resume
            </Button>
        </template>
    </Modal>
</template>

<script>
import { useResponsive } from '@/store/responsive';

import Txt from '@/components/form/txt';
import Modal from '@/components/utility/modal';
import Button from '@/components/utility/button';

export default {
    name: 'ResumeCourse',
    components: { Txt, Modal, Button },
    inject: ['$global'],
    props: {
        course: { type: Object, default: null }
    },
    emits: ['reset', 'close'],
    data() {
        return {
            viewport: useResponsive()
        };
    },
};
</script>

<style lang="less">
.modal.resume {
    background: rgba(~"var(--coal-rgb)", 0.5);
    .modal-inner {
        .footer {
            justify-content: space-between;
        }
    }
}
</style>
